const Component = () => import('./ShoppingWindow');

export { Component };
